import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Datepicker from 'components/ReusableComponents/Datepicker'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import { getHotelTodayDateString } from 'features/HealthCheck/PMS/ElectronTelemetryModal/formatHotelTime'
import { hotelStatuses, hotelStatusesEditable, hotelStatusNames } from 'main/hotelStatuses'
import moment from 'moment'
import { useState } from 'react'
import subsidiariesApi from 'services/api/subsidiaries'

import { buildStatusUpdatePayload } from './buildStatusUpdatePayload'
import styles from './EditStatusDialog.module.scss'

const EditStatusDialog = ({
  onClose,
  onSave,
  status,
  tzTimeZoneName,
  churnedEffectiveDate
}) => {
  const [newStatus, setNewStatus] = useState(status)
  const [reason, setReason] = useState('')
  const hotelToday = getHotelTodayDateString(tzTimeZoneName) || moment().format('YYYY-MM-DD')
  const [churnedDate, setChurnedDate] = useState(() => {
    if (churnedEffectiveDate) {
      return new Date(moment(churnedEffectiveDate).format('YYYY-MM-DD') + 'T00:00:00')
    }
    return new Date(hotelToday + 'T00:00:00')
  })

  const isChurnSelected = newStatus === hotelStatuses.Churned
  const isButtonDisabled = !reason || (isChurnSelected && !churnedDate)

  function updateStatus() {
    subsidiariesApi
      .updateStatus(
        buildStatusUpdatePayload({
          reason,
          status: newStatus,
          churnedDate: isChurnSelected ? churnedDate : null
        })
      )
      .then(() => {
        onSave()
      })
      .catch(() => {
        onSave()
      })
  }

  return (
    <ConfirmationDialog
      positiveMessage="Save"
      negativeMessage="Cancel"
      title="Change hotel status"
      onClose={onClose}
      onConfirm={updateStatus}
      isButtonDisabled={isButtonDisabled}
    >
      {hotelStatusesEditable.includes(status) ? (
        <Dropdown
          value={newStatus}
          isSortedAlphabetically={false}
          onChange={e => setNewStatus(e.target.value)}
          options={hotelStatusesEditable.reduce(
            (prev, curr) => ({ ...prev, [curr]: hotelStatusNames[curr] }),
            {}
          )}
        />
      ) : (
        <Dropdown
          value={newStatus}
          onChange={e => setNewStatus(e.target.value)}
          options={{
            BasicAccount: hotelStatusNames.BasicAccount,
            Churned: 'Churned',
            Paused: 'Paused',
            [status]: hotelStatusNames[status]
          }}
        />
      )}
      {isChurnSelected && (
        <div className={styles.dateField}>
          <label className={styles.fieldLabel}>Churned Date</label>
          <Datepicker
            className={styles.datePicker}
            selected={churnedDate}
            minDate={new Date(hotelToday + 'T00:00:00')}
            onChange={date => setChurnedDate(date)}
            dateFormat="MMM d, yyyy"
          />
          <div className={styles.dateHelp}>
            Hotel becomes Churned on this hotel-local date.
          </div>
        </div>
      )}
      <div className={styles.reasonField}>
        <label className={styles.fieldLabel}>Status change reason (mandatory)</label>
        <textarea
          className={styles.reasonTextarea}
          value={reason}
          rows={4}
          onChange={e => setReason(e.target.value)}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default EditStatusDialog
